import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {Offer} from '@vio/core/src/offer/types/offer'

import {Meal} from '../../accommodation/OfferPerks/Meal'

interface DealDetailsMealProps {
  mealPlan: Offer['mealPlan']
}

export const DealDetailsMeal = ({mealPlan}: DealDetailsMealProps) => {
  if (!mealPlan?.length) {
    return null
  }

  return (
    <Box display="flex" flexDirection="column" gap="s200">
      <Text variant="titleM">
        <FormattedMessageWrapper id="meals" defaultMessage="Meals" />
      </Text>
      <Meal mealPlan={mealPlan} size="md" />
    </Box>
  )
}
